export const getPageExperiencesData = (): MonetateExperience[] => {
  try {
    const pageExperiencesDataElement = document.getElementById(
      '__PAGE_EXPERIENCES_DATA__'
    );

    if (!pageExperiencesDataElement?.textContent) {
      return [];
    }

    const parsed = JSON.parse(pageExperiencesDataElement.textContent);

    const experiences = Array.isArray(parsed) ? parsed : [];
    if (experiences.length > 0) {
      return experiences.map(experience => ({
        ...experience,
        experienceName: experience.key,
      }));
    }

    return experiences;
  } catch {
    return [];
  }
};
